import {
  Box,
  Image,
  Pagination,
  Select,
  TableCell,
  TableFooter,
  TableHead,
  TableRow,
  Table as TableUI,
  Typography,
} from '@astro-ui/components'
import { dateFormat } from 'utils/helpers/date'
import useTable from './useTable'

const Table = () => {
  const { query, item, handleChangePage, handleChangeRowsPerPage } = useTable()

  return (
    <Box>
      <TableUI
        tableContainerProps={{
          sx: { borderRadius: 0, boxShadow: 'unset', borderTop: '1px solid #E9E9E9' },
        }}
        tableHeaders={[]}
        TableHeaderComponent={
          <TableHead>
            <TableRow sx={{ backgroundColor: '#FAFAFA' }}>
              <TableCell textAlign="center">
                <Typography variant="body-smallStrong" whiteSpace="nowrap">
                  No
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="body-smallStrong" whiteSpace="nowrap">
                  Nama Produk
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="body-smallStrong" whiteSpace="nowrap">
                  Nomor SKU
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="body-smallStrong" whiteSpace="nowrap">
                  Expiry Date
                </Typography>
              </TableCell>
              <TableCell textAlign="center">
                <Typography variant="body-smallStrong" whiteSpace="nowrap">
                  Jumlah
                </Typography>
              </TableCell>
              <TableCell textAlign="center">
                <Typography variant="body-smallStrong" whiteSpace="nowrap">
                  UoM
                </Typography>
              </TableCell>
            </TableRow>
          </TableHead>
        }
        TableFooterComponent={
          <TableFooter>
            <TableRow>
              <TableCell colSpan={13}>
                <Box display="flex" justifyContent="space-between">
                  <Box display="flex" gap="8px" alignItems="center">
                    <Select
                      required
                      options={['10', '20', '30', '50']}
                      value={String(query.pageSize)}
                      onChange={(val) => {
                        handleChangeRowsPerPage(Number(val))
                      }}
                    />
                    <Typography variant="body3" fontWeight={700}>
                      Tiap Halaman
                    </Typography>
                  </Box>
                  <Pagination
                    pageIndex={query?.pageIndex ? query.pageIndex + 1 : 1}
                    pageSize={query.pageSize || 10}
                    numberOfElements={item.length || 0}
                    onClick={handleChangePage}
                  />
                </Box>
              </TableCell>
            </TableRow>
          </TableFooter>
        }
      >
        {item.map((product) => (
          <TableRow key={product.supplyOrderProductDetailId}>
            <TableCell textAlign="center">1</TableCell>
            <TableCell>
              <Box display="flex" gap="8px" alignItems="center">
                <Image src={product.productImage} width="40px" height="40px" mr={12} />
                <Typography>{product.productName}</Typography>
              </Box>
            </TableCell>
            <TableCell>
              <Typography>{product.productSku}</Typography>
            </TableCell>
            <TableCell>
              <Typography whiteSpace="nowrap">
                {product.productExpDate
                  ? dateFormat({
                      date: new Date(product.productExpDate),
                      format: 'DD MMM YYYY',
                    })
                  : '-'}
              </Typography>
            </TableCell>
            <TableCell textAlign="center">
              <Typography>{product.productRequestQuantity}</Typography>
            </TableCell>
            <TableCell textAlign="center">
              <Typography>{product.productUom}</Typography>
            </TableCell>
          </TableRow>
        ))}
      </TableUI>
    </Box>
  )
}

export default Table
